import {EvaluatedData} from '../types';

const DEFAULT_VISIBILITY = true;
const DEFAULT_KEEP_IN_HTML = false;

/**
 * Evaluate visibility conditions. Default: true
 */
export const evalVisibilityConditions = (conditions: unknown): boolean => {
  if (Array.isArray(conditions)) {
    if (conditions.length > 0 && conditions.some((v) => v !== true)) {
      return false;
    }
  }
  return DEFAULT_VISIBILITY;
};

/**
 * Evaluate visibility conditions in a data object. Default: true
 */
export const memoIsVisible = (data: object): boolean => {
  if ('visibility' in data) {
    const visibility = data.visibility;
    if (
      visibility &&
      typeof visibility === 'object' &&
      'conditions' in visibility
    ) {
      const conditions = visibility.conditions;
      return evalVisibilityConditions(conditions);
    }
  }
  return DEFAULT_VISIBILITY;
};

export const isVisible = (data: EvaluatedData) =>
  data && typeof data === 'object' ? memoIsVisible(data) : DEFAULT_VISIBILITY;

/**
 * Check if a hidden element should be kept in the HTML output. Default: false
 */
export const isKeptInHtmlWhenHidden = (data: EvaluatedData): boolean => {
  if (data && typeof data === 'object' && 'visibility' in data) {
    const visibility = data.visibility;
    if (
      visibility &&
      typeof visibility === 'object' &&
      'keepInHtml' in visibility
    ) {
      const keepInHtml = visibility.keepInHtml;
      if (
        keepInHtml &&
        typeof keepInHtml === 'object' &&
        'tag' in keepInHtml &&
        typeof keepInHtml.tag === 'string'
      ) {
        return keepInHtml.tag === 'True';
      }
    }
  }
  return DEFAULT_KEEP_IN_HTML;
};
